import { render, staticRenderFns } from "./PerformanceDashboard.vue?vue&type=template&id=67a8f3b5&scoped=true&"
import script from "./PerformanceDashboard.vue?vue&type=script&lang=ts&"
export * from "./PerformanceDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a8f3b5",
  null
  
)

export default component.exports